<template>
	<section>
		<div class="d-flex flex-row align-items-center cursor-pointer set-border-info-cell" @click="handleShowContent">
			<div class="d-flex flex-row align-items-center w-90 gap-10">
				<span class="font-weight-bold fs-16">{{ item.fullName }} ({{ item.functionName }})</span>
				<b-badge pill variant="info">{{ getNumber(item.data) }}</b-badge>
			</div>
			<div class="d-flex justify-content-end w-10" @click="handleShowContent">
				<component v-if="!isCollapsed" :is="getLucideIcon(ICONS.CHEVRON_DOWN.name)" color="#06263E" :size="22" />
				<component v-if="isCollapsed" :is="getLucideIcon(ICONS.CHEVRON_UP.name)" color="#06263E" :size="22" />
			</div>
		</div>
		<b-collapse :visible="isCollapsed">
			<b-col class="p-2" v-for="(showDetailData, _key) of shortedByDate(item.data)" :key="_key">
				<div class="container-mobile animated fadeIn">
					<div class="content-detailsMyTimesheet-mobile">
						<show-detail-planning-cell :showDetailData="showDetailData" />
					</div>
				</div>
				<b-row class="divider">
					<div class="border-item"></div>
				</b-row>
			</b-col>
		</b-collapse>
	</section>
</template>
<script>
import ShowDetailPlanningCell from '@/components/EntryForCrew/Timesheets/TimesheetsEfcTables/ShowDetailPlanningCell';
import languageMessages from '@/mixins/languageMessages';
import globalMixin from '@/mixins/global.mixin';
import * as _ from 'lodash';
export default {
	name: 'RowInfoContent',
	components: { ShowDetailPlanningCell },
	mixins: [languageMessages, globalMixin],
	props: {
		item: {
			type: Object,
			required: false,
			default: () => []
		}
	},
	watch: {
		item: {
			handler(newVal) {
				return newVal;
			},
			immediate: true,
			deep: true
		}
	},
	computed: {},
	data: () => ({ isCollapsed: false, isMultiple: false }),
	methods: {
		handleShowContent() {
			this.isCollapsed = !this.isCollapsed;
		},
		getNumber(total) {
			if (!_.isNil(total)) {
				return total.length.toString().padStart(2, '0');
			}
			return '00';
		},
		shortedByDate(data) {
			const shortEd = data.sort((a, b) => new Date(a.date) - new Date(b.date));
			return shortEd;
		}
	}
};
</script>
<style lang="scss">
.set-border-info-cell {
	background-color: #f5f7f9;
	padding: 16px;
	border-radius: 8px;
	height: 50px;
}
.divider {
	display: flex;
	align-items: center;
	justify-content: center;
}
.border-item {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 10px;
	width: 100%;
	border-bottom: 4px solid #e2e6eb;
}
.gap-10 {
	gap: 10px;
}
</style>
